import { useQuery } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { announcementApi } from 'src/Services/API';

const useActiveAssetAnnouncement = () => {
  const assetId = useCurrentAssetId();

  return useQuery({
    queryKey: ['active-asset-announcement', assetId],
    queryFn: () => announcementApi.findActiveByAsset(assetId!),
    enabled: Boolean(assetId),
    staleTime: 60 * 1000,
    refetchOnWindowFocus: true,
    refetchInterval: 3 * 60 * 1000,
  });
};

export default useActiveAssetAnnouncement;
